// Studio server sets the studio_csrf cookie on every safe request
// (middleware in Plan 2). Web echoes the value back in X-CSRF-Token on
// any state-changing request — double-submit pattern.

export const CSRF_COOKIE = "studio_csrf";
export const CSRF_HEADER = "X-CSRF-Token";

// Split-run dev serves the SPA and the studio API on DIFFERENT origins, so the
// `studio_csrf` cookie lives on the API origin and can't be read here via
// document.cookie. The server also returns the token in an exposed
// `x-csrf-token` response header; api/client.ts captures it into this cache and
// readCsrfToken() falls back to it. Same-origin the cookie stays authoritative.
let cachedToken: string | null = null;
export function setCsrfToken(token: string | null): void {
  cachedToken = token;
}

function readCookieToken(): string | null {
  if (typeof document === "undefined") return null;
  const pairs = document.cookie ? document.cookie.split("; ") : [];
  for (const pair of pairs) {
    const eq = pair.indexOf("=");
    if (eq < 0) continue;
    if (pair.slice(0, eq) === CSRF_COOKIE) {
      return decodeURIComponent(pair.slice(eq + 1));
    }
  }
  return null;
}

export function readCsrfToken(): string | null {
  // The cookie is authoritative when readable (same-origin, always fresh); the
  // cached response-header token is the cross-origin fallback.
  return readCookieToken() ?? cachedToken;
}
